export default "__VITE_ASSET__f4cb2a7a__"